import * as FromUser from "src/app/store/user/selectors";
import { Pipe, PipeTransform } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { RootState } from "src/app/store";
import { map } from "rxjs/operators";

@Pipe({ name: "isModuleUnlocked" })
export class IsModuleUnlockedPipe implements PipeTransform {
  constructor(private store: Store<RootState>) {}

  public transform(moduleId: string): Observable<boolean> {
    return this.store.select(FromUser.selectEnabledModules).pipe(map(modules => modules.includes(moduleId)));
  }
}
